import { Outlet } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import CollectionsBootstrap from 'modules/it_management/lib/CollectionsBootstrap'

const Container = () => {
  const {
    employee,
    access: { id: accessId },
  } = useCurrentSession()
  return (
    <Outlet
      context={{
        currentUserId: accessId,
        employee,
      }}
    />
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
